import { render, staticRenderFns } from "./yjyzz.vue?vue&type=template&id=09a36600&scoped=true&"
import script from "./yjyzz.vue?vue&type=script&lang=js&"
export * from "./yjyzz.vue?vue&type=script&lang=js&"
import style0 from "./yjyzz.vue?vue&type=style&index=0&id=09a36600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a36600",
  null
  
)

export default component.exports